import { ClockCircleOutlined } from '@ant-design/icons'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderCronCommon } from '../common'

export const ProviderCronClient: ProviderClient = {
  key: ProviderCronCommon.key,
  description: {
    label: 'Cron Job',
    icon: <ClockCircleOutlined />,
    triggers: [
      {
        key: 'Daily',
        label: 'Daily',
        input: [],
        output: [],
      },
      {
        key: 'Recurring',
        label: 'Recurring',
        input: [],
        output: [],
      },
      {
        key: 'RecurringV2',
        label: 'Recurring V2',
        input: [],
        output: [],
      },
    ],
    actions: [],
  },
}
